
import _ from 'lodash';
import ko from 'rgs-knockout';
import kv from 'rgs-knockout-validation';


export default class Model {
	constructor (params) {
		if (ko.isObservable(params) || _.isArray(params)) {
			params = { validatable: params };
		}

		params = _.defaultsDeep({}, params, {
			//
			valid: true,

			//
			validatable: undefined,
		});

		this._valid = ko.pureComputed(() => {
			if (params.validatable && params.validatable.isValid) {
				return params.validatable.isValid();
			}

			if (_.isArray(params.validatable)) {
				return kv.group(params.validatable).isValid();
			}

			if (params.validatable) {
				const unwrappedValidatable = ko.unwrap(params.validatable);

				if (unwrappedValidatable && unwrappedValidatable.isValid) {
					return unwrappedValidatable.isValid();
				}

				return kv.group(unwrappedValidatable).isValid();
			}

			return ko.unwrap(params.valid);
		});
	}
}

